import React from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import DateTimeSlotPicker from '~/composer/composer/components/DateTimeSlotPicker';
import styled from 'styled-components';
import dayjs from 'dayjs';
import {
  selectHasTwentyFourHourTimeFormat,
  selectWeekStartsMonday,
} from '~/user/selectors';

const DateTimePickerStyle = styled.div`
  background: white;
  position: absolute;
  top: 35%;
  border: 1px solid #d5dce3;
`;

const getDateTimePickerPosition = (editMode) => ({
  right: editMode ? '9%' : '21%',
});

const DateTimeSlotPickerWrapper = ({
  onDateTimeSlotPickerSubmit,
  timezone,
  editMode,
  initialDateTime,
}) => {
  // @todo: these could move to the inner DateTimeSlotPicker once it's
  //        refactored into a functional component
  const weekStartsMonday = useSelector(selectWeekStartsMonday);
  const uses24hTime = useSelector(selectHasTwentyFourHourTimeFormat);

  return (
    <DateTimePickerStyle style={getDateTimePickerPosition(editMode)}>
      <DateTimeSlotPicker
        onSubmit={onDateTimeSlotPickerSubmit}
        shouldUse24hTime={uses24hTime}
        timezone={timezone}
        weekStartsMonday={weekStartsMonday}
        initialDateTime={initialDateTime}
      />
    </DateTimePickerStyle>
  );
};

DateTimeSlotPickerWrapper.propTypes = {
  timezone: PropTypes.string.isRequired,
  onDateTimeSlotPickerSubmit: PropTypes.func,
  editMode: PropTypes.bool,
  initialDateTime: PropTypes.instanceOf(dayjs),
};

DateTimeSlotPickerWrapper.defaultProps = {
  editMode: false,
  onDateTimeSlotPickerSubmit: () => {},
  initialDateTime: null,
};

export default DateTimeSlotPickerWrapper;
